'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = exports.Body = undefined;

var _body = require('./body');

var _body2 = _interopRequireDefault(_body);

var _header = require('./header');

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Body = _body2.default;
exports.Header = _header2.default;


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-sticky/dist/index.js
// module id = 1415
// module chunks = 0